import { network } from 'services/network';

export const updateUser = (params) => {
    return network.post('admin/bo/updateUser', params).then((response) => response.data);
};
